import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, TokenService } from '@core/services';

/**
 * Auth Guard
 * Prevents unauthenticated users from accessing protected routes
 * Redirects to /login if user is not authenticated
 *
 * @example
 * const routes: Routes = [
 *   {
 *     path: 'dashboard',
 *     component: DashboardComponent,
 *     canActivate: [authGuard]
 *   }
 * ];
 */
export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  // Check if refresh token is expired
  const refreshExpired = await tokenService.isRefreshTokenExpired$();
  if (refreshExpired) {
    authService.clear();
    tokenService.clearToken();
    return router.createUrlTree(['/login']);
  }

  // Get user
  const user = await authService.user;
  if (!user) {
    authService.clear();
    tokenService.clearToken();
    return router.createUrlTree(['/login']);
  }

  return true;
};
